import {GET_DOCUMENT_REASONS} from "../../../enums/Request/request.types";

export const layoffDismissalReasonsAction = (data) => {
    return {
        type: GET_DOCUMENT_REASONS,
        payload: data,
    };
};
